import * as z from 'zod';
import { TelPrefNoEnum } from '../enums/telPrefNo';
import { UserTypeCodeEnum } from '../enums/userTypeCode';
import { ClinicianTypeCodeEnum } from '../enums/clinicianTypeCode';

export const UserSchema = z.object({
  user_guid: z.string(),
  lucy_id: z.string(),
  user_type_code: UserTypeCodeEnum,
  user_subtype_code: ClinicianTypeCodeEnum.nullable(),
  user_role_code: z.string(),
  avatar_url: z.string().url().nullable(),
  title: z.string().nullable(),
  first_name: z.string(),
  last_name: z.string(),
  pref_name: z.string().nullable(),
  email: z.string().email(),
  dob: z.coerce.date(),
  sex: z.string(),
  job_title: z.string().nullable(),
  client_id: z.number(),
  client_name: z.string(),
  client_code: z.string(),
  membership_no: z.string().nullable(),
  nhs_number: z.string().nullable(),
  tel_mobile_no: z.string().nullable(),
  tel_other_no: z.string().nullable(),
  tel_pref_no: TelPrefNoEnum,
  validated: z.boolean(),
  enabled: z.boolean(),
  addline1: z.string().nullable(),
  addline2: z.string().nullable(),
  addline3: z.string().nullable(),
  addline4: z.string().nullable(),
  region: z.string().nullable(),
  postcode: z.string().nullable(),
  country: z.string().nullable(),
  created_date: z.coerce.date(),
  locked_date: z.coerce.date().nullable(),
  locked_mins_left: z.number(),
  login_url: z.string().url(),
  lockout_mins: z.number(),
  timeout_mins: z.number(),
  self_reg_required: z.boolean(),
  service_name: z.string().nullable(),
  pref_notification: z.string(),
  tel_validated: z.boolean(),
  email_validated: z.boolean(),
  appt_ical: z.string().nullable(),
  insured: z.boolean(),
  self_refer: z.boolean(),
  ident_prov_code: z.string(),
  provider_name: z.string(),
  provider_settings_url: z.string().nullable(),
  lang_code: z.string(),
  timezone: z.string(),
  geo_region: z.string().nullable(),
  seranova_id: z.string().nullable(),
  physitrack_id: z.string().nullable(),
  physitrack_link: z.string().url().nullable(),
  // stripe_id: z.string().nullable(),
  needs_card_details: z.coerce.boolean(),
  needs_recent_card_details: z.coerce.boolean(),
  policies_accepted: z.coerce.boolean().optional(), // Optional as will be removed in future
  new_policies: z.coerce.boolean().nullable().optional(), // Optional as will be removed in future
  restricted: z.coerce.boolean().nullable(),
  auth_type: z.string(),
  proxies_available: z.null(),
  proxy_id: z.null(),
  proxy_user_guid: z.null(),
  proxy_users_enabled: z.coerce.boolean(),
  proxy_session: z.boolean(),
  employer_code: z.string().nullable(),
  build_path: z.string().nullable(),
  nhs_client: z.boolean().nullable(),
  ro_fields: z.array(z.string()).default([]),
  gp_summary_consent: z.boolean().optional(),
  gp_investigation_consent: z.boolean().optional(),
  ask_for_gp_consent: z.boolean().optional(),
  ro_field_msg: z.coerce.boolean(),
  sso_id: z.string().nullable(),
  test_account: z.boolean().optional()
});
export type User = z.infer<typeof UserSchema>;
